{
  "access": {
    "forbidden": "Nie masz uprawnień do przeglądania ofert."
  },
  "list": {
    "pageTitle": "Oferty",
    "searchPlaceholder": "Szukaj po tytule, kliencie lub brandzie...",
    "searchAriaLabel": "Szukaj po tytule, kliencie lub brandzie",
    "loading": "Ładowanie draftów ofert...",
    "error": "Nie udało się załadować draftów ofert.",
    "retry": "Spróbuj ponownie",
    "missingBrand": "—",
    "missingClient": "Bez klienta",
    "views": {
      "mine": "Moje",
      "sharedWithMe": "Udostępnione mi",
      "all": "Wszystkie",
      "scopeAriaLabel": "Zakres ofert"
    },
    "assignedTo": {
      "ariaLabel": "Handlowiec",
      "placeholder": "Handlowiec (wszyscy)",
      "searchPlaceholder": "Szukaj osoby...",
      "empty": "Nie znaleziono osoby"
    },
    "actions": {
      "newDraft": "Nowy draft",
      "createFirstDraft": "Utwórz pierwszy draft"
    },
    "columns": {
      "brand": "Brand",
      "title": "Draft oferty",
      "status": "Status",
      "campaignNumber": "Numer kampanii",
      "validUntil": "Ważna do",
      "updatedAt": "Aktualizacja"
    },
    "rowLinkAriaLabel": "Otwórz ofertę {{title}}",
    "emptyState": {
      "title": "Brak draftów ofert",
      "description": "Nie znaleźliśmy draftów dla tego widoku. Utwórz pierwszy draft, aby rozpocząć pracę."
    },
    "pagination": {
      "status": "Strona {{page}} z {{total}}",
      "prev": "Poprzednia strona",
      "next": "Następna strona"
    },
    "bulkWithdrawAcceptance": {
      "toolbarAction": "Wycofaj akceptację",
      "toolbarActionDisabledHint": "Zaznacz co najmniej jedną zaakceptowaną ofertę.",
      "toolbarActionAccessRequiredHint": "Wybrane zaakceptowane oferty wymagają dostępu do edycji, aby wycofać akceptację.",
      "toolbarAriaLabel": "Akcje zbiorcze dla zaznaczonych ofert",
      "selectedCountSuffix_one": "zaznaczona",
      "selectedCountSuffix_few": "zaznaczone",
      "selectedCountSuffix_many": "zaznaczonych",
      "selectedCountSuffix_other": "zaznaczonych",
      "visibleCountSuffix_one": "widoczna",
      "visibleCountSuffix_few": "widoczne",
      "visibleCountSuffix_many": "widocznych",
      "visibleCountSuffix_other": "widocznych",
      "moreActionsLabel": "Więcej akcji",
      "clearSelectionLabel": "Wyczyść zaznaczenie",
      "dialog": {
        "title": "Wycofaj akceptację (zbiorczo)",
        "loadingPreview": "Sprawdzamy liczbę rezerwacji do zwolnienia…",
        "description": "Wycofasz {{offerCount}} akceptacji i zwolnisz {{reservationCount}} rezerwacji.",
        "hiddenNotice": "{{count}} poza bieżącymi wynikami.",
        "reasonLabel": "Powód (opcjonalnie)",
        "cancelBtn": "Anuluj",
        "confirmBtn": "Potwierdź"
      },
      "result": {
        "withdrawnLabel": "Wycofane",
        "skippedLabel": "Pominięte",
        "failedLabel": "Niepowodzenie",
        "closeBtn": "Zamknij",
        "offerLabel": "Oferta #{{offerId}}",
        "skippedTag": "pominięto",
        "failedTag": "błąd: {{errorCode}}",
        "releasedCount": "zwolniono {{count}}",
        "reservationId": "Rezerwacja #{{id}}",
        "reservationFailed": "Rezerwacja #{{id}} — błąd: {{errorCode}}"
      }
    }
  },
  "create": {
    "pageTitle": "Nowy draft oferty",
    "title": "Nowy draft oferty",
    "description": "Podaj klienta, aby rozpocząć pracę nad ofertą.",
    "loading": "Ładowanie klientów...",
    "loadError": "Nie udało się załadować listy klientów.",
    "retry": "Spróbuj ponownie",
    "forbidden": "Nie masz uprawnień do tworzenia draftów ofert.",
    "fields": {
      "brand": "Brand",
      "brandPlaceholder": "Wybierz brand",
      "brandUnavailable": "Klient nie ma brandów",
      "brandingMode": "Tryb brandingu",
      "brandingModePlaceholder": "Wybierz tryb brandingu",
      "client": "Klient",
      "clientPlaceholder": "Wybierz klienta",
      "campaignDuration": "Czas trwania kampanii",
      "validUntil": "Ważna do",
      "datePlaceholder": "Wybierz datę…",
      "dateRangePlaceholder": "Wybierz zakres dat…",
      "salesperson": "Handlowiec",
      "salespersonPlaceholder": "Wybierz handlowca",
      "salespersonLockedHint": "Nie masz uprawnień do przypisania oferty innemu handlowcowi.",
      "campaignNumberPreview": "Numer kampanii",
      "campaignNumberPreviewIncomplete": "Wybierz klienta i handlowca, aby zobaczyć numer kampanii",
      "campaignNumberPreviewLoading": "Wczytywanie…",
      "campaignNumberPreviewUnavailable": "Nie udało się wczytać podglądu numeru"
    },
    "inlineClient": {
      "showAction": "Utwórz nowego klienta",
      "noPermission": "Nie masz uprawnień do wykonania tej akcji.",
      "fields": {
        "name": "Nazwa klienta"
      }
    },
    "coCreators": {
      "label": "Dodaj współtwórców",
      "hint": "Po utworzeniu oferty otworzymy okno udostępniania, w którym wybierzesz osoby ze wspólnym dostępem do edycji."
    },
    "actions": {
      "cancel": "Anuluj",
      "submit": "Utwórz draft"
    },
    "errors": {
      "brandRequired": "Wybierz brand",
      "clientRequired": "Wybierz klienta",
      "clientNotFound": "Nie znaleziono klienta, wybierz innego",
      "clientSaveError": "Nie udało się zapisać klienta",
      "salespersonInvalid": "Nieprawidłowy handlowiec, wybierz innego",
      "campaignNumberExhausted": "Nie udało się wygenerować unikalnego numeru kampanii. Spróbuj ponownie.",
      "saveFailed": "Nie udało się zapisać draftu",
      "addUnitsFailed": "Draft został utworzony, ale nie udało się dodać wybranych nośników. Dodaj je ręcznie w zakładce Nośniki.",
      "dateRangeInvalid": "Data „do” musi przypadać po dacie „od”"
    }
  },
  "workspace": {
    "pageTitle": "Oferta",
    "loading": "Ładowanie draftu oferty...",
    "error": "Nie udało się załadować draftu oferty.",
    "forbidden": "Nie masz dostępu do tego draftu oferty.",
    "inTrash": "W koszu",
    "tabPlaceholder": "Ten widok wkrótce.",
    "unitsTab": {
      "loading": "Ładowanie nośników...",
      "error": "Nie udało się załadować nośników.",
      "empty": {
        "title": "Oferta jest pusta",
        "description": "Dodaj nośniki reklamowe, aby zacząć budować ofertę. Możesz skorzystać z wyszukiwarki, mapy, sugestii AI lub gotowych pakietów.",
        "primaryAction": "Dodaj pierwszy nośnik",
        "importPackage": "Importuj pakiet"
      },
      "noResults": {
        "title": "Brak wyników",
        "description": "Żaden z {{count}} nośników oferty nie pasuje do aktualnego filtra.",
        "clearFilters": "Wyczyść filtry"
      },
      "costs": {
        "maskedExplanation": "Nie masz uprawnień do wyświetlenia tej wartości."
      },
      "supplierMaskedExplanation": "Nie masz uprawnień do wyświetlenia tej wartości.",
      "footer": {
        "unitCountSingular": "{{count}} nośnik",
        "pricedCount": "{{count}} wycenionych",
        "soldCount": "{{count}} sprzedanych",
        "totalPrice": "Suma: {{value}}"
      },
      "columns": {
        "checkbox": "",
        "id": "ID",
        "identifier": "Numer GRW",
        "location": "Lokalizacja",
        "audience": "Widownia",
        "clientDecision": "Klient",
        "format": "Format",
        "supplier": "Dostawca",
        "dimensions": "Wymiary",
        "lighting": "Oświetlenie",
        "note": "Notatka",
        "actions": ""
      },
      "decision": {
        "accepted": "Zaakceptowany",
        "rejected": "Odrzucony",
        "undecided": "Oczekuje",
        "notInVersion": "Poza wybraną wersją",
        "unavailable": "Niedostępne"
      },
      "filterFields": {
        "region": "Województwo",
        "county": "Powiat",
        "agglomeration": "Aglomeracja",
        "city": "Miasto",
        "mediaType": "Typ nośnika",
        "locationSearchPlaceholder": "Szukaj województwa, powiatu, aglomeracji, miasta…",
        "locationInfoHint": "Wybrane obszary sumują się (LUB) — dodawaj lokalizacje, aby poszerzyć wyniki. Pozostałe filtry zawężają wynik.",
        "locationInfoHintLabel": "Informacja o filtrze lokalizacji",
        "lighting": "Oświetlenie",
        "supplierNumber": "Nr dostawcy",
        "grwId": "ID GRW",
        "searchPlaceholder": "Szukaj po numerze, adresie, mieście...",
        "searchAriaLabel": "Szukaj nośników",
        "material": "Materiał",
        "multiformat": "Multiformat",
        "tags": "Tagi",
        "address": "Adres",
        "area": "Powierzchnia",
        "width": "Szerokość",
        "height": "Wysokość",
        "audience": "Widownia",
        "catalogPrice": "Cena katalogowa",
        "rent": "Czynsz",
        "exposureCost": "Koszt ekspozycji",
        "additionalCosts": "Koszty dodatkowe",
        "discountedPrice": "Cena po rabacie",
        "lastMinutePrice": "Cena last minute",
        "starterPrice": "Na start",
        "productionCost": "Koszt produkcji",
        "installationCost": "Koszt montażu",
        "dismantlingCost": "Koszt demontażu",
        "clientProduction": "Produkcja",
        "clientInstallation": "Montaż",
        "clientDismantling": "Demontaż",
        "clientAdditionalFees": "Opłaty dodatkowe",
        "notes": "Uwagi",
        "roadNumber": "Nr drogi",
        "rangeMinLabel": "Min",
        "rangeMaxLabel": "Max"
      },
      "checkboxAriaLabel": "Zaznacz nośnik {{id}}",
      "rowLinkAriaLabel": "Otwórz szczegóły nośnika {{id}}",
      "noteInputAriaLabel": "Notatka dla nośnika {{id}}",
      "noteInputPlaceholder": "Dodaj notatkę...",
      "columnVisibility": {
        "toggleButton": "Kolumny",
        "sectionLabel": "Widoczność kolumn",
        "searchPlaceholder": "Szukaj kolumn...",
        "noResults": "Nie znaleziono kolumny"
      },
      "toolbar": {
        "addUnits": "Dodaj nośniki",
        "addUnitsPrimaryAriaLabel": "Dodaj nośniki do oferty",
        "addUnitsMenuAriaLabel": "Więcej opcji dodawania",
        "addModes": {
          "search": "Wyszukaj i dodaj",
          "map": "Wybierz z mapy",
          "package": "Wybierz z pakietu",
          "ai": "Sugestie AI",
          "comingSoon": "Wkrótce dostępne"
        },
        "unitCount": "{{count}} nośników",
        "unitCountOfTotal": "{{count}} z {{total}} nośników",
        "sortChipLabel": "Sortowanie: {{column}} {{direction}}",
        "sortChipClearAriaLabel": "Wyczyść sortowanie, przywróć kolejność dodania"
      },
      "placeholder": "—",
      "map": {
        "toggle": "Mapa",
        "empty": "Brak nośników ze współrzędnymi do wyświetlenia na mapie.",
        "popupDetails": "Szczegóły"
      },
      "toasts": {
        "noteConflict": "Ta oferta została zaktualizowana przez innego użytkownika. Notatka nie została zapisana.",
        "noteSaved": "Notatka zapisana",
        "noteSaveError": "Nie udało się zapisać notatki dla nośnika.",
        "removeSuccess": "Usunięto wybrane nośniki z oferty"
      },
      "bulkActions": {
        "removeSelected": "Usuń zaznaczone",
        "selectedCount_one": "zaznaczony",
        "selectedCount_few": "zaznaczone",
        "selectedCount_many": "zaznaczonych",
        "selectedCount_other": "zaznaczonych",
        "visibleCount_one": "widoczny",
        "visibleCount_few": "widoczne",
        "visibleCount_many": "widocznych",
        "visibleCount_other": "widocznych",
        "moreActions": "Więcej",
        "clearSelection": "Wyczyść zaznaczenie",
        "ariaLabel": "Akcje dla zaznaczonych nośników"
      },
      "removeConfirm": {
        "title": "Usuń zaznaczone nośniki",
        "description": "Czy na pewno chcesz usunąć zaznaczone nośniki z oferty? Tej operacji nie można cofnąć.",
        "reservationNotice": "{{reserved}} z {{total}} zaznaczonych nośników ma rezerwację tej oferty — zostanie ona zwolniona.",
        "hiddenNotice": "{{count}} poza bieżącymi wynikami.",
        "cancel": "Anuluj",
        "confirm": "Usuń"
      },
      "addDrawer": {
        "title": "Dodaj nośniki",
        "searchPlaceholder": "Szukaj po ID, mieście lub formacie...",
        "searchAriaLabel": "Szukaj nośników",
        "addButton": "Dodaj zaznaczone",
        "addButtonAriaLabel": "Dodaj zaznaczone nośniki do oferty",
        "cancelButton": "Anuluj",
        "cancelButtonAriaLabel": "Anuluj dodawanie nośników",
        "closeAriaLabel": "Zamknij szufladę dodawania nośników",
        "loading": "Ładowanie nośników...",
        "error": "Nie udało się załadować nośników.",
        "empty": "Brak nośników do wyświetlenia.",
        "selectedCount": "{{count}} zaznaczonych",
        "columns": {
          "select": "",
          "photo": "Zdjęcie",
          "grwId": "ID",
          "city": "Miasto",
          "address": "Adres",
          "format": "Format",
          "supplier": "Dostawca",
          "dimensions": "Wymiary",
          "status": "Status"
        },
        "photoAlt": "Zdjęcie nośnika {{grwId}}",
        "noPhoto": "Brak zdjęcia"
      },
      "mapOverlay": {
        "title": "Wybierz nośniki z mapy",
        "availableOnly": "Pokaż tylko dostępne",
        "selectedCount": "{{count}} nośników zaznaczonych",
        "addButton": "Dodaj {{count}} nośników",
        "cancel": "Anuluj",
        "error": "Nie udało się dodać nośników. Spróbuj ponownie."
      },
      "horizontalScrollbarAriaLabel": "Przewijanie poziome tabeli nośników"
    },
    "pricingTab": {
      "loading": "Ładowanie wycen...",
      "error": "Nie udało się załadować wycen.",
      "columns": {
        "identifier": "Numer GRW",
        "unit": "Nośnik",
        "location": "Lokalizacja",
        "dimensions": "Wymiary",
        "clientPriceNet": "Cena netto klienta",
        "clientPriceNetAriaLabel": "Cena netto klienta",
        "discountPercent": "Rabat %",
        "discountPercentAriaLabel": "Rabat procentowy",
        "lineTotal": "Kwota",
        "emptyPrice": "—",
        "checkboxAriaLabel": "Zaznacz wiersz {{id}}"
      },
      "totals": {
        "subtotal": "Suma netto",
        "discount": "Rabat",
        "grandTotal": "Razem netto",
        "additionalServices": "Usługi dodatkowe"
      },
      "toolbar": {
        "applyDiscount": "Zastosuj rabat",
        "applyDiscountAriaLabel": "Zastosuj rabat do zaznaczonych wierszy",
        "discountPopoverSelected": "Zastosuj rabat do {{count}} zaznaczonych wierszy",
        "discountPopoverHiddenCount": "{{count}} poza bieżącymi wynikami.",
        "discountPopoverAll": "Zastosuj rabat do wszystkich wierszy",
        "discountInputAriaLabel": "Wartość rabatu w procentach",
        "discountCancel": "Anuluj",
        "discountSubmit": "Zastosuj",
        "discountSubmitAriaLabel": "Potwierdź zastosowanie rabatu"
      },
      "confirmDialog": {
        "title": "Zastosuj rabat do wszystkich wierszy",
        "description": "Rabat {{discountPercent}}% zostanie zastosowany do {{count}} wierszy.",
        "rowCount": "Liczba wierszy: {{count}}",
        "filterDoesNotNarrow": "Rabat obejmie wszystkie nośniki oferty, a nie tylko te widoczne po zastosowaniu filtra.",
        "overwriteWarning": "{{count}} wierszy ma już ustawiony rabat — zostanie nadpisany.",
        "loadingRows": "Ładowanie wierszy…",
        "cancel": "Anuluj",
        "confirm": "Zastosuj do wszystkich",
        "confirmAriaLabel": "Potwierdź zastosowanie rabatu do wszystkich wierszy",
        "closeAriaLabel": "Zamknij potwierdzenie"
      },
      "toasts": {
        "conflict": "Ta oferta została zaktualizowana przez innego użytkownika. Cena nie została zapisana.",
        "saveError": "Nie udało się zapisać ceny."
      },
      "mixedCurrencyWarning": "Ustaw jedną walutę, aby zobaczyć podsumowanie."
    },
    "tabs": {
      "units": "Nośniki",
      "comments": "Komentarze",
      "versions": "Wersje",
      "decisions": "Decyzje klienta"
    },
    "versions": {
      "toolbar": {
        "title": "Historia wersji",
        "publishBtn": "Opublikuj nową wersję"
      },
      "emptyState": {
        "title": "Oferta nie została jeszcze opublikowana.",
        "description": "Opublikuj pierwszą wersję, aby udostępnić ofertę klientowi i zacząć śledzić historię zmian.",
        "publishFirstBtn": "Opublikuj pierwszą wersję"
      },
      "statusLabel": {
        "PUBLISHED": "Opublikowana",
        "SUPERSEDED": "Zastąpiona",
        "ACCEPTED": "Zaakceptowana"
      },
      "rejectedBadge": "Odrzucona",
      "activeVersionLabel": "Aktywna wersja",
      "versionBadge": "v{{number}}",
      "publishedBy": "przez użytkownika {{id}}",
      "publishedByName": "przez {{name}}",
      "unitCount": "{{count}} nośników",
      "actionsLabel": "Akcje",
      "previewTooltip": "Podgląd wersji",
      "snapshot": {
        "pageTitle": "Wersja archiwalna v{{number}}",
        "loading": "Ładowanie wersji archiwalnej...",
        "error": "Nie udało się załadować wersji archiwalnej.",
        "notFound": "Wersja archiwalna nie istnieje.",
        "forbidden": "Brak dostępu do tej wersji archiwalnej.",
        "archivalBanner": "To jest widok archiwalny wersji v{{number}}. Wersja ta nie jest aktywna.",
        "decisionsErrorBanner": "Nie udało się wczytać decyzji klienta dla tej wersji. Poniższe liczby mogą nie odzwierciedlać rzeczywistych decyzji.",
        "previewHint": "Podgląd archiwalny — akcje nie są dostępne.",
        "backLink": "Wróć do historii wersji"
      },
      "editGateBanner": {
        "title": "Ta oferta jest opublikowana. Edytowanie wymaga opublikowania nowej wersji.",
        "statusSent": "Status: Wysłana",
        "statusAccepted": "Status: Zaakceptowana — edycja może wymagać ponownej akceptacji klienta.",
        "statusConfirmed": "Status: Potwierdzona — edycja może wpłynąć na potwierdzoną kampanię.",
        "statusSold": "Status: Sprzedana — edycja może wpłynąć na sprzedaną kampanię.",
        "viewVersionsBtn": "Podgląd historii wersji",
        "cancelledTitle": "Kampania została anulowana. Edytowanie jest niedostępne."
      },
      "publishDialog": {
        "title": "Opublikuj nową wersję",
        "descriptionLabel": "Opis zmian",
        "descriptionPlaceholder": "Opisz co się zmieniło w tej wersji...",
        "charCounter": "{{current}} / 500 znaków",
        "confirmBtn": "Opublikuj",
        "cancelBtn": "Anuluj",
        "successToast": "Wersja opublikowana",
        "staleError": "Ta oferta została zaktualizowana przez kogoś innego. Odśwież stronę i spróbuj ponownie.",
        "validationError": "Opis zmian jest nieprawidłowy.",
        "genericError": "Nie udało się opublikować wersji."
      },
      "diff": {
        "dialogTitle": "Porównanie wersji",
        "dialogSubtitle": "{{from}} → {{to}}",
        "loading": "Ładowanie różnic...",
        "error": "Nie udało się załadować różnic.",
        "empty": "Brak różnic między wersjami",
        "closeAriaLabel": "Zamknij porównanie",
        "closeBtn": "Zamknij",
        "compareBtn": "Porównaj z poprzednią",
        "summary": {
          "addedLabel": "Dodane",
          "removedLabel": "Usunięte",
          "changedLabel": "Zmienione",
          "netValueLabel": "Wartość netto"
        },
        "section": {
          "addedTitle": "Dodane nośniki ({{count}})",
          "removedTitle": "Usunięte nośniki ({{count}})",
          "changedTitle": "Zmienione nośniki ({{count}})"
        },
        "fieldLabel": {
          "clientPriceNet": "Cena klienta netto",
          "discountPercent": "Rabat",
          "dateFrom": "Data od",
          "dateTo": "Data do"
        }
      },
      "lock": {
        "dialog": {
          "title": "Zarezerwuj nośniki",
          "description": "Wybierz rodzaj rezerwacji, która zostanie utworzona dla wszystkich nośników z tej wersji oferty.",
          "statusLabel": "Rodzaj rezerwacji",
          "statusSoftReservation": "Rezerwacja wstępna",
          "statusOption": "Stałka",
          "optionNeverQueuesHint": "Stałka nigdy nie trafia do kolejki oczekujących — w razie konfliktu rezerwacja zakończy się niepowodzeniem.",
          "sharedExpiryLabel": "Termin wygaśnięcia",
          "sharedExpiryHint": "Wspólny termin wygaśnięcia dla całego zestawu — obejmuje też nośniki, które trafią do kolejki. System proponuje termin wygaśnięcia; możesz go zmienić w kalendarzu.",
          "confirmBtn": "Zarezerwuj",
          "cancelBtn": "Anuluj",
          "breakdown": {
            "loading": "Obliczanie skutków rezerwacji…",
            "error": "Nie udało się obliczyć skutków rezerwacji.",
            "retryBtn": "Spróbuj ponownie",
            "empty": "Nie ma nic do zarezerwowania — wszystkie zaakceptowane nośniki są już zablokowane przez tę kampanię.",
            "lockableLabel": "Do zarezerwowania",
            "alreadyHeldLabel": "Już zablokowane",
            "queuedLabel": "Trafi do kolejki",
            "unresolvableLabel": "Nie można zarezerwować",
            "contendedNote": "Wynik nośników trafiających do kolejki może się zmienić, zanim rezerwacja zostanie potwierdzona."
          }
        },
        "result": {
          "lockedLabel": "Zarezerwowano",
          "queuedLabel": "W kolejce",
          "failedLabel": "Niepowodzenie",
          "lockedEmpty": "Brak zarezerwowanych nośników.",
          "queuedEmpty": "Brak nośników w kolejce.",
          "failedEmpty": "Brak niepowodzeń.",
          "unknownUnit": "Nieznany nośnik",
          "entryQueuedPosition": "Pozycja w kolejce: {{position}}",
          "entryExpiresOn": "Wygasa {{date}}",
          "entryFailedMinWindowViolationGeneric": "Zaakceptowany termin jest krótszy niż wymagany minimalny okres rezerwacji dla tego nośnika. Wydłuż termin i spróbuj ponownie.",
          "entryFailedReservationConflict": "Termin jest już zajęty przez inną rezerwację.",
          "entryFailedAvailabilityWindowBlocked": "Wybrany termin jest zablokowany oknem niedostępności nośnika.",
          "entryFailedGeneric": "Nie udało się zarezerwować tego nośnika.",
          "closeBtn": "Zamknij"
        },
        "toasts": {
          "notAccepted": "Nie można zarezerwować nośników — ta wersja nie jest już zaakceptowana."
        }
      },
      "withdrawAcceptance": {
        "withdrawButton": "Wycofaj akceptację",
        "registerRejectionButton": "Zarejestruj odrzucenie",
        "dialog": {
          "withdrawTitle": "Wycofaj akceptację",
          "withdrawDescription": "Wycofanie akceptacji zwolni wszystkie rezerwacje zablokowane dla tej wersji.",
          "registerRejectionTitle": "Zarejestruj odrzucenie",
          "registerRejectionDescription": "Zapiszemy, że klient odrzucił tę wersję oferty. Ta operacja nie wpływa na żadne rezerwacje.",
          "reasonLabel": "Powód (opcjonalnie)",
          "cancelBtn": "Anuluj",
          "confirmBtn": "Potwierdź",
          "supersededMessage": "Ta wersja została zastąpiona nowszą. Odśwież stronę i spróbuj ponownie.",
          "breakdown": {
            "loading": "Obliczanie skutków wycofania…",
            "error": "Nie udało się obliczyć skutków wycofania.",
            "retryBtn": "Spróbuj ponownie",
            "empty": "Nic nie zostanie zwolnione — dla tej wersji nigdy nie zablokowano żadnej rezerwacji.",
            "releasableLabel": "Zostanie zwolnione",
            "unresolvableLabel": "Nie można zwolnić",
            "unresolvableSoldReason": "Rezerwacja została sprzedana — nośnik pozostanie bez zmian."
          }
        },
        "result": {
          "releasedLabel": "Zwolnione",
          "failedLabel": "Niepowodzenie",
          "unknownUnit": "Nieznany nośnik",
          "closeBtn": "Zamknij"
        }
      },
      "unitDecisions": {
        "statusAccepted": "Zaakceptowany",
        "statusRejected": "Odrzucony",
        "statusUndecided": "Oczekuje",
        "statusUndecidedTooltip": "Klient nie podjął decyzji dla tego nośnika.",
        "statusSilent": "Akceptacja — brak terminów",
        "statusSilentTooltip": "Klient próbował zaakceptować ten nośnik, ale żaden z oferowanych terminów nie był już dostępny. To nie jest brak decyzji.",
        "summary": {
          "acceptedLabel": "Zaakceptowane",
          "silentHintAriaLabel": "Informacja o akceptacjach bez dostępnych terminów",
          "silentHint_one": "W tym {{count}} akceptacja bez dostępnych terminów — klient próbował zaakceptować, ale żaden termin nie był już wolny. Te nośniki nie zostaną zarezerwowane.",
          "silentHint_few": "W tym {{count}} akceptacje bez dostępnych terminów — klient próbował zaakceptować, ale żaden termin nie był już wolny. Te nośniki nie zostaną zarezerwowane.",
          "silentHint_many": "W tym {{count}} akceptacji bez dostępnych terminów — klient próbował zaakceptować, ale żaden termin nie był już wolny. Te nośniki nie zostaną zarezerwowane.",
          "rejectedLabel": "Odrzucone",
          "undecidedLabel": "Oczekujące",
          "acceptedValueLabel": "Wartość zaakceptowana",
          "legendAccepted": "zaakceptowane {{count}} ({{pct}}%)",
          "legendRejected": "odrzucone {{count}} ({{pct}}%)",
          "legendUndecided": "oczekujące {{count}} ({{pct}}%)"
        },
        "toolbar": {
          "searchPlaceholder": "Szukaj: adres, GRW, nr dostawcy…",
          "searchAriaLabel": "Szukaj nośnika",
          "filterAll": "Wszystkie",
          "filterAccepted": "Zaakceptowane",
          "filterRejected": "Odrzucone",
          "filterUndecided": "Oczekujące",
          "shownLabel": "{{shown}} z {{total}} nośników"
        },
        "table": {
          "colDecision": "Decyzja",
          "colUnit": "Nośnik",
          "colType": "Typ / wymiary",
          "colAcceptedDates": "Zaakceptowane daty",
          "colPrice": "Cena",
          "colReservation": "Rezerwacja",
          "noAcceptedDates": "Brak dostępnych terminów",
          "reservationNone": "Brak",
          "reservationSoft": "Rez. wstępna",
          "reservationOption": "Stałka",
          "reservationSold": "Sprzedany",
          "emptyTitle": "Brak nośników spełniających kryteria",
          "emptyDescription": "Zmień filtr lub wyczyść wyszukiwanie.",
          "clearFiltersBtn": "Wyczyść filtry",
          "sortLabel": "Sortowanie: {{field}} {{dir}}"
        },
        "release": {
          "dialog": {
            "breakdown": {
              "loading": "Obliczanie skutków zwolnienia…",
              "error": "Nie udało się obliczyć skutków zwolnienia.",
              "retryBtn": "Spróbuj ponownie",
              "empty": "Nie ma nic do zwolnienia — klient nie odrzucił żadnego nośnika.",
              "releasedLabel": "Zostanie zwolniony",
              "nothingToReleaseLabel": "Brak aktywnej rezerwacji",
              "unresolvableLabel": "Nie można rozwiązać",
              "unresolvableSoldReason": "Rezerwacja została sprzedana — nośnik pozostanie bez zmian."
            }
          },
          "result": {
            "releasedLabel": "Zwolniono",
            "nothingToReleaseLabel": "Nic do zwolnienia",
            "failedLabel": "Nieudane",
            "releasedEmpty": "Nie zwolniono żadnych nośników.",
            "nothingToReleaseEmpty": "Każdy odrzucony nośnik miał aktywną rezerwację.",
            "failedEmpty": "Brak niepowodzeń.",
            "unknownUnit": "Nieznany nośnik"
          }
        },
        "remove": {
          "button": "Usuń odrzucone nośniki",
          "disabledHint": "Brak odrzuconych nośników do usunięcia",
          "dialog": {
            "title": "Usuń odrzucone nośniki",
            "description": "Nośniki odrzucone przez klienta w tej wersji opuszczą roboczą wersję oferty. Jeśli nadal mają aktywną rezerwację, zostanie ona zwolniona w tym samym kroku.",
            "confirmBtn": "Usuń",
            "cancelBtn": "Anuluj",
            "breakdown": {
              "loading": "Obliczanie skutków usunięcia…",
              "error": "Nie udało się obliczyć skutków usunięcia.",
              "retryBtn": "Spróbuj ponownie",
              "empty": "Nie ma nic do usunięcia — klient nie odrzucił żadnego nośnika.",
              "removedLabel": "Zostanie usunięty",
              "unresolvableLabel": "Nie można usunąć",
              "unresolvableSoldReason": "Rezerwacja została sprzedana — nośnik pozostanie bez zmian."
            }
          },
          "result": {
            "removedLabel": "Usunięto",
            "failedLabel": "Nieudane",
            "removedEmpty": "Nie usunięto żadnych nośników.",
            "failedEmpty": "Brak niepowodzeń.",
            "unknownUnit": "Nieznany nośnik",
            "closeBtn": "Zamknij"
          }
        }
      }
    },
    "decisions": {
      "emptyNoVersions": "Ta oferta nie ma jeszcze żadnej opublikowanej wersji.",
      "versionSelectLabel": "Wersja",
      "versionOptionLabel": "v{{number}} — {{status}}"
    },
    "availabilityTab": {
      "loading": "Ładowanie dostępności...",
      "error": "Nie udało się załadować dostępności.",
      "noDefaultDateRange": "Aby zobaczyć dostępność, ustaw domyślny zakres dat na tej ofercie.",
      "setDefaultDateRangeCta": "Ustaw czas trwania kampanii",
      "noUnits": "Ta oferta nie ma jeszcze żadnych nośników.",
      "toggleLabel": "Dostępność",
      "granularityLabel": "Granulacja",
      "granularityOptions": {
        "day": "Dni",
        "week": "Tygodnie",
        "halfMonth": "Pół miesiąca",
        "month": "Miesiące"
      },
      "unitHeader": "Nośnik / Miasto",
      "soldLabel": "Sprzedany",
      "conflict": {
        "sold": "Sprzedane",
        "reservedOther": "Zarezerwowane",
        "optionOther": "Stałka",
        "softReservation": "Miękka rezerwacja",
        "hardReservation": "Twarda rezerwacja",
        "cancelSoldBtn": "Anuluj sprzedaż"
      },
      "popover": {
        "reserveMulti": "Zarezerwuj {{count}} {{periodPlural}} dla {{unitLabel}}: {{periods}}?",
        "reserveSingle": "Zarezerwuj okres: {{period}} dla {{unitLabel}}?",
        "releaseLabel": "Zwolnij rezerwację?",
        "occupiedByOther": "Zajęty przez inną ofertę",
        "periodPlural": "okresy",
        "autoSnapWarning": "{{mediaTypeLabel}} nie obsługuje rezerwacji dziennych. Zarezerwuje okres {{snappedLabel}}.",
        "addOptionBtn": "Dodaj stałkę",
        "reserveBtn": "Zarezerwuj",
        "upgradeHardBtn": "Twarda",
        "closeSaleBtn": "Sprzedaj",
        "releaseBtn": "Tak, zwolnij",
        "cancelBtn": "Anuluj",
        "closeBtn": "Zamknij"
      },
      "countdown": {
        "label": "Czas do wygaśnięcia:"
      },
      "toasts": {
        "reservationConflict": "Termin jest już zajęty przez inną rezerwację.",
        "optionExtensionImpossible": "Nie można przedłużyć stałki – termin jest zablokowany przez inną rezerwację.",
        "staleState": "Stan rezerwacji zmienił się przed wykonaniem akcji. Odśwież stronę i spróbuj ponownie.",
        "notFound": "Nie znaleziono rezerwacji lub wariantu nośnika.",
        "forbidden": "Nie masz uprawnień do wykonania tej akcji.",
        "validationError": "Nieprawidłowe dane rezerwacji.",
        "availabilityWindowBlocked": "Nie można utworzyć rezerwacji – wybrany termin jest zablokowany oknem niedostępności nośnika.",
        "minWindowViolation_one": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dzień (wybrano {{selectedDays}}).",
        "minWindowViolation_few": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
        "minWindowViolation_many": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
        "minWindowViolation_other": "Minimalny okres rezerwacji dla tego typu nośnika to {{minWindowDays}} dni (wybrano {{selectedDays}}).",
        "genericError": "Nie udało się wykonać akcji na rezerwacji."
      }
    },
    "header": {
      "campaignNumber": "Numer kampanii",
      "campaignDurationUnset": "Ustaw czas trwania kampanii",
      "missingClient": "Bez klienta",
      "moreActions": "Więcej opcji",
      "validityCountdown": "Ważne jeszcze {{days}} dni",
      "actions": {
        "confirmCampaign": "Potwierdź kampanię",
        "secureRemainingUnits": "Zabezpiecz pozostałe nośniki",
        "recordSale": "Potwierdź sprzedaż",
        "adminChangeStatus": "Admin: zmień status",
        "downloadOrderDocument": "Pobierz zamówienie",
        "reservePreliminary": "Zarezerwuj wstępnie"
      },
      "reservePreliminaryDialog": {
        "title": "Zarezerwuj wstępnie — wersja {{number}}",
        "reserveGroupLabel": "Do zarezerwowania",
        "releaseGroupLabel": "Do zwolnienia",
        "confirmBtn": "Zarezerwuj wstępnie",
        "cancelBtn": "Anuluj",
        "closeBtn": "Zamknij",
        "resultReserveTitle": "Wynik rezerwacji",
        "resultReleaseTitle": "Wynik zwolnienia",
        "resultReserveFailed": "Nie udało się zarezerwować nośników. Spróbuj ponownie.",
        "resultReleaseFailed": "Nie udało się zwolnić rezerwacji odrzuconych nośników. Spróbuj ponownie."
      },
      "finalizationPanel": {
        "title": "Finalizacja kampanii",
        "ariaLabel": "Postęp finalizacji kampanii",
        "steps": {
          "clientAcceptance": "Akceptacja klienta",
          "campaignConfirmation": "Potwierdzenie kampanii",
          "sale": "Sprzedaż"
        },
        "stepStatus": {
          "done": "Ukończono",
          "current": "Bieżący krok",
          "upcoming": "Nadchodzący krok"
        },
        "draft": {
          "readyToShare": "Oferta jest w przygotowaniu. Aby ruszyć dalej, udostępnij ją klientowi przyciskiem „Udostępnij klientowi” u góry.",
          "needsUnits": "Oferta jest w przygotowaniu. Zacznij od dodania nośników w zakładce Nośniki."
        },
        "sent": {
          "title": "Krok 1 z 3 — Czekamy na decyzję klienta",
          "description": "Kolejne kroki (potwierdzenie kampanii, sprzedaż) odblokują się, gdy klient zaakceptuje ofertę."
        },
        "accepted": {
          "title": "Krok 2 z 3 — Potwierdź kampanię",
          "description": "Zamieni rezerwacje wstępne na twarde dla nośników zaakceptowanych przez klienta. Bez tego kroku mogą one wygasnąć.",
          "blockedNote": "Nie masz uprawnień do potwierdzenia kampanii — poproś kogoś z dostępem do edycji tej oferty.",
          "reserveBlockedNote": "Nie masz uprawnień do wstępnej rezerwacji nośników — poproś kogoś z dostępem do edycji tej oferty i uprawnieniem do zarządzania rezerwacjami.",
          "reserveDisabledHint": "Nie ma nic do zarezerwowania ani do zwolnienia dla tej wersji."
        },
        "confirmed": {
          "title": "Krok 3 z 3 — Potwierdź sprzedaż",
          "description": "Nośniki są zabezpieczone twardą rezerwacją pod numerem {{campaignNumber}}. Potwierdzenie sprzedaży zamknie je jako sprzedane.",
          "unsecuredAlert": "Część nośników zaakceptowanych po potwierdzeniu kampanii nie ma jeszcze twardej rezerwacji.",
          "secureBlockedNote": "Nie masz uprawnień do zabezpieczenia pozostałych nośników — poproś kogoś z dostępem do edycji tej oferty.",
          "blockedNote": "Nie masz uprawnień do potwierdzenia sprzedaży — poproś kogoś z dostępem do edycji tej oferty."
        },
        "sold": {
          "title": "Kampania sprzedana",
          "description": "Wszystkie kroki finalizacji są zamknięte. Zamówienie zostaje dostępne jako zapis tego, co zostało sprzedane."
        },
        "orderDocument": {
          "draftLabel": "Pobierz zamówienie (projekt)",
          "draftHint": "Ta oferta nie ma jeszcze numeru kampanii (starsza oferta) — dokument ma dopisek PROJEKT, dopóki numer nie zostanie nadany."
        }
      },
      "confirmDialog": {
        "title": "Potwierdź kampanię",
        "description": "Ta akcja zabezpieczy zaakceptowane przez klienta nośniki tej kampanii.",
        "helpText": "Ten krok jest nieodwracalny bez interwencji administratora.",
        "cancel": "Anuluj",
        "confirm": "Potwierdź kampanię",
        "close": "Zamknij potwierdzenie kampanii",
        "loadingBreakdown": "Sprawdzamy, co zmieni potwierdzenie kampanii…",
        "breakdownError": "Nie udało się sprawdzić, co zmieni potwierdzenie kampanii. Odśwież i spróbuj ponownie.",
        "retry": "Spróbuj ponownie",
        "nothingToSecure": "Nie ma nic do zabezpieczenia — wszystkie zaakceptowane nośniki są już zabezpieczone.",
        "queueNote": "Dołączenie do kolejki oznacza zgłoszenie zainteresowania tym terminem, a nie jego zabezpieczenie."
      },
      "saleDialog": {
        "title": "Potwierdź sprzedaż",
        "loadingPreview": "Sprawdzamy liczbę nośników do zamknięcia…",
        "previewError": "Nie udało się sprawdzić, które nośniki zamknie ta sprzedaż. Odśwież i spróbuj ponownie.",
        "nothingToClose": "Ta kampania nie ma żadnych aktywnych rezerwacji do zamknięcia.",
        "description_one": "Ta akcja zamknie {{count}} nośnik jako sprzedany.",
        "description_few": "Ta akcja zamknie {{count}} nośniki jako sprzedane.",
        "description_many": "Ta akcja zamknie {{count}} nośników jako sprzedane.",
        "helpText": "Użyj tej akcji dla zamówienia opłaconego w całości. Jeśli zamówienie zostało opłacone częściowo, zamknij poszczególne nośniki jako sprzedane z poziomu rezerwacji, a sprzedaż całej kampanii zarejestruj później.",
        "cancel": "Anuluj",
        "confirm": "Potwierdź sprzedaż",
        "close": "Zamknij potwierdzenie sprzedaży",
        "closedStat": "Do zamknięcia",
        "skippedStat": "Pominięte",
        "skippedHintLabel": "Dlaczego te nośniki zostaną pominięte",
        "skippedHint_one": "Ten nośnik ma aktywną rezerwację na tej ofercie, ale klient nie zaakceptował go w bieżącej wersji oferty, więc domyślnie nie zostanie sprzedany razem z kampanią. Zaznacz opcję poniżej, aby mimo to go sprzedać.",
        "skippedHint_few": "Te nośniki mają aktywną rezerwację na tej ofercie, ale klient nie zaakceptował ich w bieżącej wersji oferty, więc domyślnie nie zostaną sprzedane razem z kampanią. Zaznacz opcję poniżej, aby mimo to je sprzedać.",
        "skippedHint_many": "Te nośniki mają aktywną rezerwację na tej ofercie, ale klient nie zaakceptował ich w bieżącej wersji oferty, więc domyślnie nie zostaną sprzedane razem z kampanią. Zaznacz opcję poniżej, aby mimo to je sprzedać.",
        "includeNotAccepted_one": "Sprzedaj również nośnik poza akceptacją klienta ({{count}})",
        "includeNotAccepted_few": "Sprzedaj również nośniki poza akceptacją klienta ({{count}})",
        "includeNotAccepted_many": "Sprzedaj również nośniki poza akceptacją klienta ({{count}})",
        "columns": {
          "outcome": "Sprzedaż",
          "periods": "Okresy",
          "reservationStatus": "Rezerwacja"
        },
        "outcome": {
          "willClose": "Zostanie sprzedany",
          "skipped": "Pominięty",
          "alreadySold": "Już sprzedany"
        }
      },
      "outcomeBreakdown": {
        "columns": {
          "outcome": "Wynik",
          "period": "Okres"
        },
        "group": {
          "newlyReserved": "Nowo zarezerwowane",
          "raisedFromPreliminary": "Podniesione z rezerwacji wstępnej",
          "alreadySecured": "Już zabezpieczone",
          "queued": "W kolejce",
          "notSecured": "Nie zabezpieczono",
          "sold": "Sprzedane",
          "alreadySold": "Już sprzedane",
          "skippedNotAccepted": "Pominięte (poza akceptacją)",
          "notClosed": "Nie zamknięto",
          "unrecognized": "Nierozpoznany wynik"
        },
        "queuePosition": "Pozycja w kolejce: {{position}}",
        "unrecognizedHint": "Ten wynik nie jest jeszcze obsługiwany w tej wersji aplikacji. Odśwież stronę, aby zobaczyć pełny szczegół.",
        "contendedNote": "Wynik nośników zależnych od terminu innej osoby może się zmienić, zanim akcja zostanie zatwierdzona."
      },
      "statusDialog": {
        "title": "Zmień status oferty",
        "description": "Nowy status: {{status}}",
        "reasonLabel": "Powód zmiany statusu",
        "reasonPlaceholder": "Opisz powód zmiany statusu",
        "cancel": "Anuluj",
        "submit": "Zapisz status",
        "close": "Zamknij zmianę statusu",
        "errors": {
          "reasonMin": "Powód musi mieć co najmniej 5 znaków.",
          "reasonMax": "Powód nie może przekroczyć 500 znaków."
        }
      },
      "menu": {
        "clientShare": "Udostępnij klientowi...",
        "edit": "Edytuj",
        "manageSharing": "Zarządzaj udostępnianiem",
        "moveToTrash": "Przenieś do kosza",
        "cancelCampaign": "Anuluj kampanię",
        "editCampaignNumber": "Zmień numer kampanii"
      },
      "cancelDialog": {
        "title": "Anuluj kampanię",
        "description": "Kampania otrzyma status Anulowana. Nie zwalnia to jej rezerwacji — pozostaną bez zmian.",
        "reasonLabel": "Powód anulowania",
        "reasonPlaceholder": "Opisz powód anulowania kampanii",
        "cancel": "Wróć",
        "confirm": "Anuluj kampanię",
        "close": "Zamknij anulowanie kampanii",
        "errors": {
          "reasonMin": "Powód musi mieć co najmniej 5 znaków.",
          "reasonMax": "Powód nie może przekroczyć 500 znaków."
        }
      },
      "campaignNumberDialog": {
        "title": "Zmień numer kampanii",
        "description": "Zmień już nadany numer kampanii, np. dopisując inicjały lub miesiąc.",
        "fieldLabel": "Numer kampanii",
        "cancel": "Anuluj",
        "confirm": "Zapisz numer",
        "close": "Zamknij zmianę numeru kampanii",
        "errors": {
          "required": "Podaj numer kampanii.",
          "tooLong": "Numer kampanii nie może przekroczyć 64 znaków."
        }
      },
      "clientShare": {
        "title": "Udostępnij klientowi",
        "trigger": "Udostępnij klientowi",
        "close": "Zamknij udostępnianie klientowi",
        "infoLabel": "Więcej informacji",
        "linkSection": "Link publiczny dla klienta",
        "linkInfo": "Każdy z tym linkiem zobaczy ofertę bez logowania. Wygenerowanie nowego linku unieważnia poprzedni.",
        "previewSection": "Widok klienta",
        "previewInfo": "Otwiera ofertę dokładnie tak, jak zobaczy ją klient — bez wpływu na statystyki otwarć.",
        "openPreview": "Otwórz podgląd",
        "requiresPreviewPublish": "Opublikuj ofertę, aby otworzyć podgląd klienta."
      },
      "sharing": {
        "actions": {
          "addRole": "Dodaj rolę",
          "addUser": "Dodaj użytkownika",
          "cancel": "Anuluj",
          "remove": "Usuń",
          "save": "Zapisz udostępnianie"
        },
        "close": "Zamknij zarządzanie udostępnianiem",
        "currentShares": "Aktualne udostępnienia",
        "empty": "Brak udostępnień.",
        "fields": {
          "role": "Rola",
          "rolePermission": "Poziom uprawnień roli",
          "rolePlaceholder": "Wybierz rolę",
          "user": "Użytkownik",
          "userPermission": "Poziom uprawnień użytkownika",
          "userPlaceholder": "Wybierz użytkownika"
        },
        "permissions": {
          "view": "Podgląd",
          "viewEdit": "Podgląd + edycja"
        },
        "removeAriaLabel": "Usuń udostępnienie {{id}}",
        "roleFallback": "Rola #{{id}}",
        "title": "Zarządzaj udostępnianiem",
        "toasts": {
          "saveError": "Nie udało się zapisać zmian udostępniania."
        },
        "userFallback": "Użytkownik #{{id}}"
      },
      "trash": {
        "actions": {
          "cancel": "Anuluj",
          "confirm": "Przenieś do kosza",
          "confirmAriaLabel": "Potwierdź przeniesienie do kosza"
        },
        "close": "Zamknij potwierdzenie przeniesienia do kosza",
        "description": "Przeniesiony draft zniknie z listy Moje oferty i pozostanie tylko w koszu.",
        "title": "Przenieś do kosza",
        "toasts": {
          "error": "Nie udało się przenieść draftu do kosza."
        }
      },
      "drawer": {
        "cancel": "Anuluj",
        "close": "Zamknij panel edycji",
        "save": "Zapisz",
        "title": "Edytuj ofertę"
      },
      "fields": {
        "brand": "Brand",
        "brandingMode": "Tryb brandingu",
        "campaignDuration": "Czas trwania kampanii",
        "datePlaceholder": "Wybierz datę…",
        "dateRangePlaceholder": "Wybierz zakres dat…",
        "defaultDateFrom": "Czas trwania kampanii — od",
        "defaultDateTo": "Czas trwania kampanii — do",
        "defaultPeriodGranularity": "Domyślna granularność okresu",
        "notificationEmails": "Emaile powiadomień",
        "priceColumnsConfig": "Definicje kolumn cenowych",
        "publishWithoutPrices": "Publikuj bez cen",
        "title": "Tytuł oferty",
        "validUntil": "Oferta ważna do"
      },
      "options": {
        "noBrand": "Bez brandu",
        "brandingMode": {
          "rwGroup": "Grupa RW",
          "whiteLabel": "White label"
        },
        "periodGranularity": {
          "halfMonth": "Pół miesiąca",
          "month": "Miesiąc",
          "week": "Tydzień"
        }
      },
      "toasts": {
        "approved": "Kampania została potwierdzona. Nadany numer: {{campaignNumber}}.",
        "approvalPartial_one": "{{count}} nośnik nie został zabezpieczony.",
        "approvalPartial_few": "{{count}} nośniki nie zostały zabezpieczone.",
        "approvalPartial_many": "{{count}} nośników nie zostało zabezpieczonych.",
        "approvalConflict": "Status oferty zmienił się wcześniej. Odśwież widok i spróbuj ponownie.",
        "approvalForbidden": "Nie masz uprawnień do potwierdzenia tej kampanii.",
        "approvalError": "Nie udało się potwierdzić kampanii.",
        "approvalUnrecognizedOutcome": "Część wyników potwierdzenia kampanii nie jest jeszcze obsługiwana w tej wersji aplikacji. Odśwież stronę, aby zobaczyć pełny szczegół.",
        "conflict": "Ta oferta została przed chwilą zaktualizowana przez innego użytkownika.",
        "saveError": "Nie udało się zapisać zmian.",
        "saved": "Zapisano",
        "statusConflict": "Status oferty zmienił się wcześniej. Odśwież widok i spróbuj ponownie.",
        "statusForbidden": "Nie masz uprawnień do zmiany statusu oferty.",
        "statusSaved": "Status oferty zmieniono na {{status}}. Numer kampanii: {{campaignNumber}}.",
        "statusSaveError": "Nie udało się zmienić statusu oferty.",
        "statusUnchanged": "Wybierz inny status oferty, aby zapisać zmianę.",
        "statusValidation": "Popraw dane formularza i spróbuj ponownie.",
        "cancelled": "Kampania została anulowana.",
        "cancelAlreadyCancelled": "Ta kampania jest już anulowana.",
        "cancelForbidden": "Nie masz uprawnień do anulowania tej kampanii.",
        "cancelOfferTrashed": "Ta oferta została przeniesiona do kosza.",
        "cancelError": "Nie udało się anulować kampanii.",
        "campaignNumberUpdated": "Numer kampanii został zmieniony.",
        "campaignNumberTaken": "Ten numer kampanii jest już używany przez inną ofertę.",
        "campaignNumberNotAllocated": "Ta oferta nie ma jeszcze nadanego numeru kampanii.",
        "campaignNumberForbidden": "Nie masz uprawnień do zmiany numeru kampanii.",
        "campaignNumberOfferTrashed": "Ta oferta została przeniesiona do kosza.",
        "campaignNumberError": "Nie udało się zapisać numeru kampanii.",
        "orderDocumentNoAcceptedVersion": "Ta oferta nie ma jeszcze zaakceptowanej wersji.",
        "orderDocumentNoAcceptedUnits": "Ta oferta nie ma żadnych zaakceptowanych nośników.",
        "orderDocumentUnpricedWarning_one": "Pobrano zamówienie, ale {{count}} pozycja nie ma jeszcze ceny.",
        "orderDocumentUnpricedWarning_few": "Pobrano zamówienie, ale {{count}} pozycje nie mają jeszcze ceny.",
        "orderDocumentUnpricedWarning_many": "Pobrano zamówienie, ale {{count}} pozycji nie ma jeszcze ceny.",
        "orderDocumentTooManyUnits": "Zbyt wiele zaakceptowanych nośników, aby wygenerować dokument.",
        "orderDocumentMixedCurrency": "Zaakceptowane nośniki mają różne waluty — nie można wygenerować jednego dokumentu.",
        "orderDocumentError": "Nie udało się pobrać zamówienia.",
        "saleRecorded_one": "Sprzedaż zarejestrowana. Zamknięto {{count}} nośnik jako sprzedany.",
        "saleRecorded_few": "Sprzedaż zarejestrowana. Zamknięto {{count}} nośniki jako sprzedane.",
        "saleRecorded_many": "Sprzedaż zarejestrowana. Zamknięto {{count}} nośników jako sprzedane.",
        "saleRecordedZero": "Kampania została zarejestrowana jako sprzedana. Żaden nośnik nie wymagał zamknięcia.",
        "salePartial_one": "{{count}} nośnik nie mógł zostać zamknięty.",
        "salePartial_few": "{{count}} nośniki nie mogły zostać zamknięte.",
        "salePartial_many": "{{count}} nośników nie mogło zostać zamkniętych.",
        "saleSkipped_one": "Pominięto {{count}} nośnik spoza akceptacji klienta.",
        "saleSkipped_few": "Pominięto {{count}} nośniki spoza akceptacji klienta.",
        "saleSkipped_many": "Pominięto {{count}} nośników spoza akceptacji klienta.",
        "saleConflict": "Status kampanii zmienił się wcześniej. Odśwież widok i spróbuj ponownie.",
        "saleForbidden": "Nie masz uprawnień do zarejestrowania sprzedaży tej kampanii.",
        "saleError": "Nie udało się zarejestrować sprzedaży kampanii."
      }
    }
  },
  "clientOffer": {
    "pageTitle": "Widok klienta",
    "loading": "Ładowanie oferty...",
    "error": "Nie udało się załadować oferty.",
    "notPublished": "Ta oferta nie została jeszcze opublikowana.",
    "status": {
      "accepted": "Zaakceptowana"
    },
    "footer": {
      "supersededMessage": "Odśwież stronę, aby zobaczyć najnowszą wersję."
    },
    "noPickablePeriodsHint": "Brak wolnych terminów do wyboru",
    "acceptedDecisionsDroppedWarning_one": "Uwaga: {{count}} zaakceptowany nośnik nie został zapisany. Skontaktuj się z handlowcem.",
    "acceptedDecisionsDroppedWarning_few": "Uwaga: {{count}} zaakceptowane nośniki nie zostały zapisane. Skontaktuj się z handlowcem.",
    "acceptedDecisionsDroppedWarning_many": "Uwaga: {{count}} zaakceptowanych nośników nie zostało zapisanych. Skontaktuj się z handlowcem.",
    "inquiry": {
      "success": "Zapytanie zostało wysłane",
      "error": "Nie udało się wysłać zapytania"
    }
  },
  "publicOffer": {
    "linkExpired": "Link wygasł",
    "linkInvalid": "Nieprawidłowy link",
    "linkExpiredDescription": "Ten link do oferty wygasł. Skontaktuj się ze swoim handlowcem, aby uzyskać nowy link.",
    "linkInvalidDescription": "Ten link do oferty jest nieprawidłowy lub został odwołany.",
    "success": {
      "brandName": "Grupa RW",
      "brandSubtitle": "Oferta reklamowa",
      "title": "Dziękujemy za akceptację oferty",
      "description": "Twoja decyzja została zapisana. Potwierdzimy dostępność wybranych nośników i skontaktujemy się z Tobą osobno, gdy otrzymamy potwierdzenie po naszej stronie.",
      "savedLabel": "Decyzja zapisana",
      "nextTitle": "Co wydarzy się dalej",
      "steps": {
        "saved": {
          "title": "Akceptacja zapisana",
          "description": "Otrzymaliśmy Twój wybór nośników i terminów."
        },
        "availability": {
          "title": "Potwierdzamy dostępność",
          "description": "Sprawdzimy dostępność wybranych nośników."
        },
        "contact": {
          "title": "Skontaktujemy się z Tobą",
          "description": "Przekażemy potwierdzenie i ustalimy dalsze kroki."
        }
      },
      "closeHint": "Możesz bezpiecznie zamknąć tę stronę lub zobaczyć zapisane decyzje poniżej.",
      "backToOfferAction": "Zobacz zapisane decyzje"
    }
  },
  "publicLink": {
    "generate": "Generuj link publiczny",
    "generateShort": "Wygeneruj link",
    "inactive": "Brak aktywnego linku",
    "copy": "Kopiuj link",
    "copyHint": "Kliknij, aby skopiować",
    "regenerate": "Wygeneruj nowy",
    "revoke": "Odwołaj",
    "active": "Aktywny",
    "expires": "Ważny do {{date}}",
    "copied": "Link skopiowany",
    "revoked": "Link odwołany",
    "generated": "Link wygenerowany",
    "regenerateToCopy": "Wygeneruj nowy link, aby skopiować",
    "autoPublishFailed": "Nie udało się opublikować oferty przed wygenerowaniem linku. Spróbuj ponownie.",
    "viewedAt": "Wyświetlono przez klienta {{date}}",
    "notViewedYet": "Jeszcze nie wyświetlono",
    "cancel": "Anuluj",
    "regenerateDialog": {
      "title": "Wygenerować nowy link?",
      "body": "Obecny link, który ma klient, przestanie działać. Będziesz mógł skopiować nowy link zaraz po wygenerowaniu.",
      "acknowledgement": "Rozumiem, że obecny link klienta przestanie działać"
    },
    "revokeDialog": {
      "title": "Odwołać link?",
      "body": "Link klienta przestanie działać natychmiast.",
      "acknowledgement": "Rozumiem, że link klienta przestanie działać natychmiast"
    }
  },
  "status": {
    "DRAFT": "DRAFT",
    "SENT": "Wysłana",
    "ACCEPTED": "Zaakceptowana",
    "CONFIRMED": "Potwierdzona",
    "SOLD": "Sprzedana",
    "EXPIRED": "Wygasła",
    "CANCELLED": "Anulowana"
  },
  "clientOfferReviewV2": {
    "readOnlyRecordedHint": "Ta decyzja została zapisana wraz z akceptacją oferty i nie może być już zmieniona.",
    "header": {
      "brandName": "Grupa RW",
      "loggedInAs": "Zalogowano:",
      "versionPrefix": "wersja"
    },
    "banner": {
      "acceptedTitle": "Oferta zaakceptowana. Dziękujemy!",
      "acceptedDescription": "Handlowiec otrzymał Twoją odpowiedź wraz z decyzjami dla nośników ({{count}} zaakceptowanych, wartość {{value}}).",
      "rejectedTitle": "Oferta została odrzucona.",
      "rejectedDescription": "Handlowiec otrzymał Twoją odpowiedź i skontaktuje się z Tobą.",
      "expiredTitle": "Oferta wygasła.",
      "expiredDescription": "Skontaktuj się z handlowcem, aby otrzymać aktualną wersję.",
      "previewTitle": "Podgląd wersji — widok archiwalny.",
      "previewDescription": "Wszystkie akcje są widoczne, ale nieaktywne.",
      "pendingTitle": "Oferta oczekuje na Twoją decyzję.",
      "statusAccepted": "Zaakceptowana",
      "statusRejected": "Odrzucona",
      "statusExpired": "Wygasła",
      "statusSent": "Wysłana"
    },
    "statusBanner": {
      "diffTitle": "Co się zmieniło od wersji {{prevVersion}}",
      "diffCollapse": "Zwiń",
      "diffShow": "Pokaż zmiany ({{count}})",
      "diffTagPrice": "Cena",
      "diffTagRemoved": "Usunięty",
      "diffTagAdded": "Nowy"
    },
    "summaryStats": {
      "unitsLabel": "Nośniki",
      "citiesUnit": "miast",
      "campaignLabel": "Kampania",
      "totalNetLabel": "Suma netto",
      "accepted": "Zaakceptowane",
      "rejected": "Odrzucone",
      "pending": "Oczekujące",
      "pendingHint": "Nośniki bez Twojej decyzji. Możesz zaakceptować lub odrzucić każdy z osobna — decyzje wyślemy razem z odpowiedzią na ofertę.",
      "acceptedValueLabel": "Wartość zaakceptowana:",
      "breakdownSummary": "{{accCount}} ({{pctAcc}}%) zaakceptowanych · {{rejCount}} ({{pctRej}}%) odrzuconych · {{pendCount}} ({{pctPend}}%) oczekujących",
      "availableUnitsSuffix": "{{availCount}} dostępnych nośników"
    },
    "filterPanel": {
      "city": "Miasto",
      "format": "Typ nośnika",
      "price": "Cena",
      "priceUnit": "zł",
      "voivodeship": "Województwo",
      "supplier": "Dostawca",
      "width": "Szerokość",
      "height": "Wysokość",
      "dimensionUnit": "m",
      "panel": {
        "allLabel": "Wszystkie",
        "searchPlaceholder": "Szukaj…",
        "selectedCount": "Wybrano: {{count}}",
        "clearAriaLabel": "Wyczyść filtr {{fieldId}}",
        "clearAllLabel": "Wyczyść filtry",
        "addFilterLabel": "+ Dodaj filtr"
      },
      "range": {
        "minLabel": "Min",
        "maxLabel": "Max",
        "applyLabel": "Zastosuj",
        "clearLabel": "Wyczyść"
      }
    },
    "toolbar": {
      "searchPlaceholder": "Adres, miasto, numer…",
      "filterAll": "Wszystkie",
      "filterAccepted": "Zaakceptowane",
      "filterRejected": "Odrzucone",
      "filterPending": "Oczekujące",
      "photoModeAriaLabel": "Tryb zdjęć",
      "photoModeLabel": "Zdjęcia:",
      "photoModeLarge": "Duże",
      "photoModeSmall": "Małe",
      "photoModeNone": "Brak",
      "sortAriaLabel": "Sortowanie",
      "sortLabel": "Sortowanie:",
      "sortByCity": "Miasto",
      "sortByPrice": "Cena",
      "sortByDecision": "Decyzja",
      "granularityAriaLabel": "Ziarnistość terminów",
      "granularityLabel": "Ziarnistość:",
      "granularityHalfMonth": "Połówki miesiąca",
      "granularityMonth": "Miesiące",
      "granularityWeek": "Tygodnie",
      "granularityDay": "Dni",
      "selectAllAriaLabel": "Wybierz wszystkie",
      "selectAllHint": "Wybierz wszystkie (zaakceptuj dostępne nośniki)",
      "clearAllAriaLabel": "Wyczyść wybór",
      "clearAllHint": "Wyczyść wybór (cofnij wszystkie decyzje)",
      "pageSizeAriaLabel": "Liczba wyników na stronie",
      "pageSizeLabel": "Na stronie:",
      "pageSizeAllOption": "Wszystkie",
      "pageSizeCustomAriaLabel": "Własna liczba wyników na stronie",
      "pageSizeCustomPlaceholder": "Własna…"
    },
    "unitCard": {
      "soldLabel": "Sprzedany",
      "acceptedBadge": "✓ Zaakceptowany",
      "rejectedBadge": "✕ Odrzucony",
      "priceConfirmationPending": "do potwierdzenia",
      "netSuffix": "netto",
      "locateAction": "Pokaż na mapie",
      "acceptAction": "Zaakceptuj nośnik",
      "undoAcceptAction": "Cofnij akceptację",
      "acceptDisabledHint": "Brak wolnych terminów do wyboru",
      "rejectAction": "Odrzuć nośnik",
      "undoRejectAction": "Cofnij odrzucenie",
      "lockedHint": "Ten nośnik został już sprzedany w ramach tej oferty, dlatego decyzja jest wiążąca. Aby ją zmienić, skontaktuj się z handlowcem.",
      "seeDetails": "Zobacz szczegóły",
      "grwNumberLabel": "Nr",
      "discountedPriceLabel": "Cena po rabacie"
    },
    "periodChips": {
      "free": "wolny",
      "reserved": "rezerwacja",
      "sold": "sprzedany",
      "selected": "wybrany",
      "selectedRangeSummary": "Wybrano {{selectedCount}} z {{totalCount}} terminów",
      "toggleAriaLabel": "Termin {{periodLabel}}",
      "willAcceptHint": "Wybranie tego terminu zaakceptuje ten nośnik."
    },
    "photoBlock": {
      "zoomHint": "Kliknij, aby powiększyć zdjęcia",
      "soldLabel": "SPRZEDANE",
      "placeholderCaptionLarge": "zdjęcie nośnika — pełny kadr",
      "placeholderCaptionSmall": "zdjęcie nośnika"
    },
    "unitList": {
      "noResultsTitle": "Brak nośników spełniających kryteria",
      "clearFilters": "Wyczyść filtry"
    },
    "pagination": {
      "previous": "Poprzednia strona",
      "next": "Następna strona",
      "pageAriaLabel": "Strona {{page}}"
    },
    "confirmationModals": {
      "selectAllTitle": "Zaakceptować wszystkie nośniki?",
      "selectAllBody": "Oznaczysz {{availCount}} dostępnych nośników jako zaakceptowane (z domyślnymi terminami). Dotychczasowe decyzje zostaną nadpisane. Nic nie zostanie wysłane — odpowiedź prześlesz osobno.",
      "selectAllCancel": "Anuluj",
      "selectAllConfirm": "Zaakceptuj wszystkie",
      "clearAllTitle": "Wyczyścić wszystkie decyzje?",
      "clearAllBody": "Cofniesz decyzje dla {{accCount}} zaakceptowanych i {{rejCount}} odrzuconych nośników, wraz z wybranymi terminami. Tej operacji nie można cofnąć.",
      "clearAllCancel": "Anuluj",
      "clearAllConfirm": "Wyczyść decyzje",
      "acceptOfferTitle": "Zaakceptować ofertę (wersja {{versionNumber}})?",
      "acceptOfferBody": "Wyślemy Twoją odpowiedź wraz z decyzjami dla nośników: {{accCount}} zaakceptowanych, {{rejCount}} odrzuconych, {{pendCount}} bez decyzji. Wartość zaakceptowanych nośników: {{value}} netto.",
      "acceptOfferCancel": "Anuluj",
      "acceptOfferConfirm": "Zaakceptuj ofertę"
    },
    "lightbox": {
      "close": "Zamknij",
      "previous": "Poprzednie zdjęcie",
      "next": "Następne zdjęcie",
      "frame1": "ujęcie z poziomu ulicy",
      "frame2": "ujęcie z bliska",
      "frame3": "ujęcie nocne (podświetlenie)"
    },
    "mapPanel": {
      "fullscreenToggle": "Pełny ekran",
      "growListWidth": "Zwiększ szerokość listy",
      "growMapWidth": "Zwiększ szerokość mapy",
      "legendAccepted": "zaakceptowany",
      "legendRejected": "odrzucony",
      "legendDigital": "digital",
      "legendOther": "pozostałe",
      "legendSold": "sprzedany"
    },
    "footerBar": {
      "disclaimer": "Decyzje dla nośników zostaną wysłane razem z odpowiedzią na całą ofertę.",
      "summary": "{{accCount}} zaakceptowanych · {{rejCount}} odrzuconych · {{pendCount}} oczekujących · wartość {{value}}",
      "accept": "Zaakceptuj ofertę (wersja {{versionNumber}})",
      "customPeriodsChip": "ze zmienionymi terminami",
      "customPeriodsCount_one": "{{count}} nośnik ze zmienionymi terminami",
      "customPeriodsCount_few": "{{count}} nośniki ze zmienionymi terminami",
      "customPeriodsCount_many": "{{count}} nośników ze zmienionymi terminami",
      "customPeriodsTitle": "Zmienione terminy",
      "customPeriodsRestoreHint": "Przywraca proponowane terminy dla wszystkich nośników. Tej operacji nie można cofnąć.",
      "restoreCustomPeriods": "Przywróć domyślne",
      "acceptDisabledNoAcceptedHint": "Brak zaakceptowanych nośników."
    },
    "inquiry": {
      "submit": "Wyślij zapytanie",
      "success": "Zapytanie o terminy zostało wysłane."
    }
  }
}
